'use client';

import { Loader } from '@paypoteam/ui-components';

export default function Loading() {
    return (
        <div className="relative h-[90vh] w-full">
            <Loader />
        </div>
    );
}
